import { TranslatePipe } from "src/app/app.module";
import {
  OfferService,
  Testimonial,
  TopEvent,
  TopHotel,
} from "../interface/home-page.interface";

export const TopHotels: TopHotel[] = [
  {
    image: "assets/images/crd-hotel1.png",
    title: "Nearby Attraction",
    price: "20",
    description: "Dining, drinking and snacking",
    currency: "$",
  },
  {
    image: "assets/images/crd-hotel2.png",
    title: "Popway Residence Tennoji",
    price: "24",
    description: "Dining, drinking and snacking",
    currency: "$",
  },
  {
    image: "assets/images/crd-hotel3.png",
    title: "Nearby Attraction",
    price: "20",
    description: "Dining, drinking and snacking",
    currency: "$",
  },
  {
    image: "assets/images/crd-hotel2.png",
    title: "Popway Residence Tennoji",
    price: "24",
    description: "Dining, drinking and snacking",
    currency: "$",
  }
];

export const TopEventsList: TopEvent[] = [
  {
    image: "assets/images/event-crd1.png",
    title:
      " Official match breaks for some of the most exciting football leagues in the world.",
    id: "1",
  },
  {
    image: "assets/images/event-crd2.png",
    title:
      "Official match breaks for some of the most exciting football leagues in the world.",
    id: "2",
  },
  {
    image: "assets/images/event-crd3.png",
    title:
      "Official match breaks for some of the most exciting football leagues in the world.",
    id: "3",
  },
  {
    image: "assets/images/event-crd3.png",
    title:
      "Official match breaks for some of the most exciting football leagues in the world.",
    id: "4",
  },
];

export const TestimonialList: Testimonial[] = [
  {
    image: "assets/images/pc1.png",
    title: "Traveler",
    name: "Kavin Knox",
    description:
      "Lorem ipsum dolor sit amet consectetur. Eu id libero urna mi amet orci pulvinar natoque vulputate. Dictumst magna posuere proin",
  },
  {
    image: "assets/images/pc1.png",
    title: "Traveler",
    name: "Kavin Knox",
    description:
      "Lorem ipsum dolor sit amet consectetur. Eu id libero urna mi amet orci pulvinar natoque vulputate. Dictumst magna posuere proin",
  },
  {
    image: "assets/images/pc1.png",
    title: "Traveler",
    name: "Kavin Knox",
    description:
      "Lorem ipsum dolor sit amet consectetur. Eu id libero urna mi amet orci pulvinar natoque vulputate. Dictumst magna posuere proin",
  },
  {
    image: "assets/images/pc1.png",
    title: "Traveler",
    name: "Kavin Knox",
    description:
      "Lorem ipsum dolor sit amet consectetur. Eu id libero urna mi amet orci pulvinar natoque vulputate. Dictumst magna posuere proin",
  },
  {
    image: "assets/images/pc1.png",
    title: "Traveler",
    name: "Kavin Knox",
    description:
      "Lorem ipsum dolor sit amet consectetur. Eu id libero urna mi amet orci pulvinar natoque vulputate. Dictumst magna posuere proin",
  },
];

export const OfferServiceList: OfferService[] = [
  {
    image: "assets/images/crd-1.png",
    title: TranslatePipe.transform(
      "homePage.categorySection.servicesList.ticketBooking.title"
    ),
    description:
      "Lorem ipsum dolor sit amet consectetur. Elit massa sit in molestie elit.",
  },
  {
    image: "assets/images/crd-2.png",
    title: "Sports Booking",
    description:
      "Lorem ipsum dolor sit amet consectetur. Elit massa sit in molestie elit.",
  },
  {
    image: "assets/images/crd-3.png",
    title: "Event Booking",
    description:
      "Lorem ipsum dolor sit amet consectetur. Elit massa sit in molestie elit.",
  },
  {
    image: "assets/images/crd-4.png",
    title: "Hotel & Flight",
    description:
      "Lorem ipsum dolor sit amet consectetur. Elit massa sit in molestie elit.",
  },
];
